module.exports = __webpack_public_path__ + "static/img/e1.a8134d2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/e1.jpg
// module id = zYW4
// module chunks = 1